import { Component } from '@angular/core';
import { register } from '@piqet-angular/data';
import { CustomModalService, registeredIconIndex, userStatus } from '@piqet-angular/shared';
import { ICellRendererParams } from 'ag-grid-community';
@Component({
  selector: 'piqet-angular-history-renderer',
  templateUrl: './history-renderer.component.html',
  styleUrls: ['./history-renderer.component.css'],
})
export class HistoryRendererComponent {
  icons: any = [];
  emailStatusList: any;
  params: any;
  userName: string = '';
  negativeEmailStatusList: any;
  constructor(private modal: CustomModalService) {}
  agInit(params: any): void {
    this.params = params;
    this.userName = params.data.firstName + ' ' + params.data.lastName;
    this.emailStatusList = params.emailStatusList;
    this.negativeEmailStatusList = params.negativeEmailStatusList;
    this.icons = [
      {
        id: 1,
        title: 'Document',
        path: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM5 15h14v-2H5v2zm0-4h14V9H5v2z',
      },
      {
        id: 2,
        title: 'Email',
        path: 'M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0-2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z',
      },
      {
        id: 3,
        title: 'Video',
        path: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z',
      },
      {
        id: 4,
        title: 'Chat',
        path: 'M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z',
      },
      {
        id: 5,
        title: 'User',
        path: 'M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 8c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm-6 4c.22-.72 3.31-2 6-2 2.7 0 5.8 1.29 6 2H9zm-3-3v-3h3v-2H6V7H4v3H1v2h3v3z',
      },
    ];
  }

  getIconColor(iconId: number): string {
    if (this.params?.data?.emailStatus) {
      const emailStatus = JSON.parse(this.params.data.emailStatus);
      const statusItem = emailStatus.find((item: any) => item.Type === iconId);
      return statusItem ||
        (iconId == registeredIconIndex && this.params.data?.userStatus == userStatus.Trial) ||
        (iconId == registeredIconIndex && this.params.data?.userStatus == userStatus.Purchased)
        ? '#9747FF'
        : '#808080';
    }
    return '#808080';
  }

  getTooltipText(iconId: number): string {
    const statusItem = this.emailStatusList.find((item: any) => item.id === iconId);
    if (this.params.data.emailStatus) {
      const emailStatus = JSON.parse(this.params.data.emailStatus);
      const combineArray = emailStatus
        ? emailStatus.find((item: any) => item.Type === statusItem.id)
        : null;
      if (iconId == registeredIconIndex && this.params.data?.userStatus == userStatus.Trial) {
        return `User has registered for a free trial`;
      } else if (
        iconId == registeredIconIndex &&
        this.params.data?.userStatus == userStatus.Purchased
      ) {
        return `User has purchased a license`;
      } else if (statusItem) {
        const statusText = statusItem.name;
        if (combineArray) {
          const sentOnText = combineArray.SentOn ? ` ${combineArray.SentOn}` : 'Not sent yet';
          return `${statusText} <br> ${sentOnText}`;
        } else {
          return `${statusText} <br> Not sent yet`;
        }
      }
    }
    return `${statusItem.name} <br> Not sent yet`;
  }

  seeDetails() {
    this.modal.invoke('HistoryDetails', {
      initialState: {
        isVerification: true,
        statusList: this.emailStatusList,
        negativeStatusList: this.negativeEmailStatusList,
        emailStatus: this.params.data?.emailStatus ? JSON.parse(this.params.data?.emailStatus) : [],
        userName: this.userName,
        userData: this.params.data,
        userStatus: this.params.data?.userStatus,
        organizationNames: this.params.data?.organizationNames,
      },
      class: 'modal-lg',
    });
  }
}
